import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import type {
	ExperimentalUpdateShortcuts as UpdateShortcutMutationData,
	ExperimentalUpdateShortcutsVariables as UpdateShortcutMutationVars,
} from './__types__/ExperimentalUpdateShortcuts.ts';

export const useExperimentalUpdateShortcutLinksMutation = (): [
	(
		options?:
			| {
					variables?: UpdateShortcutMutationVars | undefined;
					update?:
						| ((
								cache: null,
								result: {
									data?: UpdateShortcutMutationData | null | undefined;
								},
						  ) => void)
						| undefined;
					optimisticResponse?:
						| UpdateShortcutMutationData
						| ((vars: UpdateShortcutMutationVars) => UpdateShortcutMutationData)
						| undefined;
			  }
			| undefined,
	) => Promise<{
		data: UpdateShortcutMutationData | undefined;
	}>,
	{
		data: UpdateShortcutMutationData | undefined;
		loading: boolean;
		error: ApolloErrorInterop | undefined;
		called: boolean;
	},
] => {
	return useExperimentalMutation<
		UpdateShortcutMutationData,
		UpdateShortcutMutationVars,
		UpdateShortcutLinksResponse
	>({
		url: '/wiki/rest/ia/1.0/link/batch',
		method: 'POST',
		body: (variables) => JSON.stringify(variables),
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResult: ({ quickLinks }) => {
			const links = quickLinks.map(({ id, position, styleClass, title, url }) => ({
				id: String(id),
				position: String(position),
				styleClass,
				title,
				url,
			}));

			return {
				experimentalUpdateShortcutLinks: {
					quickLinks: links,
					__typename: 'ExperimentalQuickLinks',
				},
			};
		},
	});
};

interface QuickLinkResponse {
	id: number;
	position: number;
	styleClass: string;
	title: string;
	url: string;
}

interface UpdateShortcutLinksResponse {
	quickLinks: QuickLinkResponse[];
}
